import React, { Component } from "react";
import { lsStore } from "./utils";
import TimeoutModal from "./modal/timeoutModal";

export default class Timer extends Component {
  state = {
    minutes: this.props.timer.minutes,
    seconds: this.props.timer.seconds,
    isPaused: this.props.timer.isPaused,
  };

  componentDidUpdate(prevProps) {
    //   console.log(prevProps, this.props)
    if (
      this.props.timer.minutes !== prevProps.timer.minutes ||
      this.props.timer.hours !== prevProps.timer.hours || 
      this.props.timer.isPaused !== prevProps.timer.isPaused
    ) {
      this.setState(this.props.timer, () => {
        lsStore("timer", this.state);
        clearInterval(this.myInterval);
        this.startTimer();
      });
    }
  }

  startTimer = () => {
    this.myInterval = setInterval(() => {
      if (this.state.isPaused) return;

      const { seconds, minutes } = this.state;

      if (seconds > 0) {
        this.setState(
          ({ seconds }) => ({
            seconds: seconds - 1,
          }),
          () => {
            lsStore("timer", this.state);
          }
        );
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
          lsStore("timer", this.state);
        } else {
          this.setState(
            ({ minutes }) => ({
              minutes: minutes - 1,
              seconds: 59,
            }),
            () => {
              lsStore("timer", this.state);
            }
          );
        }
      }
    }, 1000);
  };
  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  render() {
    const { minutes, seconds } = this.state;
    return (
      <div>
        {minutes === 0 && seconds === 0 ? (
          <TimeoutModal
            isOpen={true}
            levelsCleared={this.props.currentPuzzle}
            currentPuzzle={this.props.currentPuzzle}
            totalMoves={this.props.totalMoves}
            gameOverSound={this.props.gameOverSound}
            // berriesCollected
            // finalScore
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
                position: 'absolute',
                bottom: 0,
                paddingBottom: '14px'
              }}
            >
              <button
                style={{ minWidth: "210px" }}
                className="btn"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  this.props.resetTimer();
                  this.props.selectPuzzle(0);
                }}
              >
                RESTART
                <img src={require("./static/restart.svg")} alt="play-button" />
              </button>
            </div>
          </TimeoutModal>
        ) : (
          this.state.isPaused === true && this.props.gameMode === 'free' ? ''
          : 
          <span>
            {minutes < 10 ? `0${minutes}` : minutes}:
            {seconds < 10 ? `0${seconds}` : seconds}
          </span>
        )}
      </div>
    );
  }
}

